import { render, staticRenderFns } from "./ContainerWithoutMenu.vue?vue&type=template&id=1ff4256a&"
import script from "./ContainerWithoutMenu.vue?vue&type=script&lang=js&"
export * from "./ContainerWithoutMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports